(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bc-earrings-grid"]) return;
  try {
    
(() => {
  const safe = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const normal = value => String(value ?? '').toLowerCase().replace(/[–—]/g, '-');
  const finishOf = (values, fallback) => {
    const s = values.join(' / ');
    if (/rose[ -]?gold/.test(s)) return 'rose';
    if (/gold[ -]?(tone|plated|color|colour)|(?:^|\/\s*)gold\s*(?:\/|$)/.test(s)) return 'gold';
    if (/silver|white[ -]?gold|platinum|rhodium/.test(s)) return 'silver';
    return fallback;
  };
  const colourOf = (values, names, fallback) => {
    const selected=values.filter((value,i)=>/stone|moissanite colo|gem|colou?r|design|moissanite and metal/.test(names[i]||'')&&(!/metal|finish/.test(names[i]||'')||/moissanite and metal/.test(names[i]||''))).join(' / ').replace(/white[ -]?gold|rose[ -]?gold|gold[ -]?tone|silver[ -]?tone/g,'');
    if (/black|yellow|gray|grey|blue|green|pink|red|purple|violet|orange|rainbow|multicol|iridescent|champagne/.test(selected)) return 'coloured';
    if (/\b(white|clear|colourless|colorless)\b/.test(selected)) return 'white';
    return fallback;
  };
  function matches(product, meta, state) {
    if(state.style!=='all'&&!meta.styles?.includes(state.style))return null;
    const names=product.options.map(normal), candidates=[];
    for(let i=0;i<product.ids.length;i++){
      const values=[product.o1[i]||'',product.o2[i]||'',product.o3[i]||''].map(normal);
      const label=values.join(' / ');
      const design=values.filter((v,i)=>/design|style/.test(names[i]||'')).join(' / ');
      let variantStyle=meta.variantStyles?.[product.ids[i]];
      if(!variantStyle&&/cuff/.test(design))variantStyle='cuffs';
      if(!variantStyle&&/\bdrops?\b|dangle|tassel|threader/.test(design))variantStyle='drops';
      if(!variantStyle&&/stud|climber|ear jacket/.test(design))variantStyle='studs';
      if(!variantStyle&&/hoop|huggie/.test(design))variantStyle='hoops';
      if(state.style!=='all'&&variantStyle&&state.style!==variantStyle)continue;
      if(meta.quantity==='mixed'&&/necklace/.test(label)&&!/earring|set/.test(label))continue;
      const finish=finishOf(values,meta.finish), colour=colourOf(values,names,meta.colour), price=Number(product.prices[i])/100;
      if(state.finish!=='all'&&finish!==state.finish)continue;
      if(state.colour!=='all'&&colour!==state.colour)continue;
      if(state.price==='under50'&&price>=50)continue;
      if(state.price==='50to100'&&(price<50||price>100))continue;
      if(state.price==='over100'&&price<=100)continue;
      candidates.push({id:product.ids[i],price,available:product.available[i],image:product.images?.length===product.ids.length?product.images[i]:null});
    }
    if(!candidates.length)return null;
    const available=candidates.filter(v=>v.available), choices=available.length?available:candidates;
    choices.sort((a,b)=>a.price-b.price);
    const useMatchedImage=state.finish!=='all'||state.colour!=='all'||state.style!=='all'||meta.quantity==='mixed';
    return {...product,image:useMatchedImage?(choices[0].image||product.image):product.image,meta,matched:choices,price:choices[0].price,variant:choices[0].id,available:available.length>0};
  }
  class BCEarrings extends HTMLElement {
    connectedCallback(){
      if(this.ready)return;this.ready=true;
      this.state={style:'all',colour:'all',finish:'all',sort:'featured',price:'all'};
      this.text=JSON.parse(this.querySelector('[data-texts]').textContent);
      this.grid=this.querySelector('[data-grid]');this.count=this.querySelector('[data-count]');this.more=this.querySelector('[data-more]');
      this.money=new Intl.NumberFormat(this.dataset.locale||'en',{style:'currency',currency:this.dataset.currency||'USD'});
      this.featured=(JSON.parse(this.dataset.featured||'[]')||[]).map(String);
      this.querySelector('[value="under50"]').textContent=this.text.under+' '+this.money.format(50);
      this.querySelector('[value="50to100"]').textContent=this.money.format(50)+' – '+this.money.format(100);
      this.querySelector('[value="over100"]').textContent=this.text.over+' '+this.money.format(100);
      this.querySelector('.bc-e-controls').hidden=false;
      this.querySelector('form').addEventListener('submit',e=>e.preventDefault());
      this.querySelectorAll('[data-style]').forEach(b=>b.addEventListener('click',()=>{this.state.style=b.dataset.style;this.update()}));
      this.querySelectorAll('[data-filter]').forEach(input=>input.addEventListener('change',()=>{this.state[input.dataset.filter]=input.value;this.update()}));
      this.querySelector('form').addEventListener('reset',e=>{e.preventDefault();this.state={style:'all',colour:'all',finish:'all',sort:'featured',price:'all'};this.querySelectorAll('[data-filter]').forEach(i=>i.value=this.state[i.dataset.filter]);this.update()});
      this.more.addEventListener('click',()=>{this.shown+=24;this.render()});
    }
    async load(){
      if(this.products)return;
      if(!this.loading)this.loading=(async()=>{
        const metadataResponse=await fetch(this.dataset.index,{credentials:'same-origin'});if(!metadataResponse.ok)throw Error('index');
        const index=await metadataResponse.json();
        const getPage=async page=>{
          const url=new URL(this.dataset.path,location.origin);url.searchParams.set('section_id','bc-earrings-data');url.searchParams.set('page',page);url.searchParams.set('sort_by','best-selling');
          const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)url.searchParams.set('preview_theme_id',preview);
          const res=await fetch(url,{credentials:'same-origin'});if(!res.ok)throw Error('page');
          const doc=new DOMParser().parseFromString(await res.text(),'text/html'), node=doc.querySelector('[data-bc-earrings-page]');if(!node)throw Error('section');return JSON.parse(node.textContent);
        };
        const first=await getPage(1);const pages=[first];
        for(let page=2;page<=first.pages;page+=2){const tasks=[getPage(page)];if(page+1<=first.pages)tasks.push(getPage(page+1));pages.push(...await Promise.all(tasks))}
        const items=pages.flatMap(p=>p.products);if(new Set(items.map(p=>p.id)).size!==first.total)throw Error('coverage');
        this.products=items;this.index=index;
      })().catch(error=>{this.loading=null;throw error});
      await this.loading;
    }
    async update(){
      const revision=this.revision=(this.revision||0)+1;this.count.textContent=this.text.loading;this.setAttribute('aria-busy','true');
      this.querySelectorAll('[data-style]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.style===this.state.style)));
      try{await this.load();if(revision!==this.revision)return;this.shown=24;this.render()}catch(error){if(revision===this.revision)this.count.textContent=this.text.error}finally{if(revision===this.revision)this.removeAttribute('aria-busy')}
    }
    render(){
      let selected=this.products.map(p=>matches(p,this.index[p.id]||{styles:[]},this.state)).filter(Boolean);
      if(this.state.sort==='low')selected.sort((a,b)=>a.price-b.price);else if(this.state.sort==='high')selected.sort((a,b)=>b.price-a.price);else selected.sort((a,b)=>{const x=this.featured.indexOf(String(a.id)),y=this.featured.indexOf(String(b.id));return (x<0?999:x)-(y<0?999:y)});
      this.count.textContent=`${selected.length} ${this.text.results}`;
      this.querySelector('[data-pagination]').hidden=true;this.more.hidden=selected.length<=this.shown;
      this.grid.innerHTML=selected.slice(0,this.shown).map(p=>{
        const destination=new URL(p.url,location.origin);destination.searchParams.set('variant',p.variant);
        const preview=new URL(location.href).searchParams.get('preview_theme_id');if(preview)destination.searchParams.set('preview_theme_id',preview);
        const url=safe(destination.pathname+destination.search), vary=p.matched.some(v=>v.price!==p.price), quantity=p.meta.quantity==='pair'?'':this.text[p.meta.quantity]||'';
        if(p.image){const imageURL=new URL(p.image,location.origin);imageURL.searchParams.set('width','540');p.image=imageURL.href;}
        return `<article class="bc-e-card"><a class="bc-e-image" href="${url}">${p.image?`<img src="${safe(p.image)}" alt="${safe(p.title)}" width="540" height="540" loading="lazy">`:''}</a><h2 class="bc-e-title"><a href="${url}">${safe(p.title)}</a></h2>${quantity?`<p class="bc-e-detail">${safe(quantity)}</p>`:''}${Number(p.reviews)>0?`<div class="loox-rating" data-id="${safe(p.id)}" data-rating="${safe(p.rating)}" data-raters="${safe(p.reviews)}"></div>`:''}<p class="bc-e-price">${vary?safe(this.text.from)+' ':''}${safe(this.money.format(p.price))}</p>${p.available?'':`<p class="bc-e-detail">${safe(this.text.sold_out)}</p>`}</article>`;
      }).join('')||`<p class="bc-e-empty">${safe(this.text.empty)}</p>`;
    }
  }
  if(typeof module!=='undefined'&&module.exports)module.exports={matches,colourOf,finishOf};
  if(!customElements.get('bc-earrings'))customElements.define('bc-earrings',BCEarrings);
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
